import { LoadablePaint } from '@confluence/loadable';

export const SpotlightLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Spotlight" */ './Spotlight')).Spotlight,
});
